import * as React from "react";
import {SvgIconProps} from "@mui/material/SvgIcon";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import WidthNormalOutlinedIcon from "@mui/icons-material/WidthNormalOutlined";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import PentagonOutlinedIcon from "@mui/icons-material/PentagonOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import HexagonOutlinedIcon from "@mui/icons-material/HexagonOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import DonutSmallOutlinedIcon from "@mui/icons-material/DonutSmallOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CopyrightOutlinedIcon from "@mui/icons-material/CopyrightOutlined";
import ViewDayOutlinedIcon from "@mui/icons-material/ViewDayOutlined";

export const IconMap: { [key: string]: React.ElementType<SvgIconProps> } = {
    desktop: AssessmentOutlinedIcon,
    'user-add': WidthNormalOutlinedIcon,
    pound: LocalAtmOutlinedIcon,
    product: PentagonOutlinedIcon,
    shop: MonetizationOnOutlinedIcon,
    tag: SpaceDashboardOutlinedIcon,
    crown: HexagonOutlinedIcon,
    read: ArticleOutlinedIcon,
    gateway: DnsOutlinedIcon,
    interation: DonutSmallOutlinedIcon,
    fund: CategoryOutlinedIcon,
    setting: SettingsOutlinedIcon,
    copyright: CopyrightOutlinedIcon,
    task: ViewDayOutlinedIcon
}